import { render, staticRenderFns } from "./AlignmentSettings.vue?vue&type=template&id=29f74fb3&scoped=true&"
import script from "./AlignmentSettings.vue?vue&type=script&lang=js&"
export * from "./AlignmentSettings.vue?vue&type=script&lang=js&"
import style0 from "./AlignmentSettings.vue?vue&type=style&index=0&id=29f74fb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f74fb3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VFlex,VLayout,VRadio,VRadioGroup,VSubheader})
